import { db, auth } from "../config/main_config"
import { getValidToken } from "./utils/getValidToken.util";
import { window } from "./utils/window.util" // using this instead of the below for window access as typescript does complain when you have multiple of the same interfaces across different files
import { onAuthReady } from "@/lib/authState";

// declare global {
//   interface Window {
//     companyID: string;
//     mspID: string;
//     assignees?: any[];
//   }
// }

export const getAssignees = async () => {
  const msps: any[] = [];
  return await db.collection('customers')
    .doc(window.companyID)
    .get()
    .then(async (customerDoc) => {
      if (customerDoc.exists) {
        if (
          (customerDoc.data()?.hasOwnProperty('mspDetails') &&
            customerDoc.data()?.mspDetails.hasOwnProperty('techPartner') &&
            customerDoc.data()?.mspDetails.techPartner.hasOwnProperty('msp') &&
            customerDoc.data()?.mspDetails.techPartner.msp !== null &&
            customerDoc.data()?.mspDetails.techPartner.msp !== '') ||
          (customerDoc.data()?.hasOwnProperty('mspDetails') &&
            customerDoc.data()?.mspDetails.hasOwnProperty('msp') &&
            customerDoc.data()?.mspDetails.msp !== null &&
            customerDoc.data()?.mspDetails.msp !== '')
        ) {
          let mspID =
            customerDoc.data()?.hasOwnProperty('mspDetails') &&
              customerDoc.data()?.mspDetails.hasOwnProperty('techPartner') &&
              customerDoc.data()?.mspDetails.techPartner.hasOwnProperty('msp') &&
              customerDoc.data()?.mspDetails.techPartner.msp !== null &&
              customerDoc.data()?.mspDetails.techPartner.msp !== ''
              ? customerDoc.data()?.mspDetails.techPartner.msp
              : customerDoc.data()?.mspDetails.msp;
          window.mspID = mspID;
          msps.push(mspID);
          sessionStorage.setItem('web-mspID', window.mspID);
          sessionStorage.setItem('web-mspName', window.mspID);
        }
        if (
          (customerDoc.data()?.hasOwnProperty('mspDetails') &&
            customerDoc.data()?.mspDetails.hasOwnProperty('businessPartner') &&
            customerDoc.data()?.mspDetails.businessPartner.hasOwnProperty('msp') &&
            customerDoc.data()?.mspDetails.businessPartner.msp !== null &&
            customerDoc.data()?.mspDetails.businessPartner.msp !== '')
        ) {
          let mspID = customerDoc.data()?.mspDetails.businessPartner.msp
          window.mspID = mspID;
          msps.push(mspID);
          sessionStorage.setItem('web-mspID', window.mspID);
          sessionStorage.setItem('web-mspName', window.mspID);
        }
        await db.collection("users").doc(auth.currentUser?.uid).get().then(async (user) => {
          if (sessionStorage.getItem('web-mspID') !== undefined && sessionStorage.getItem('web-mspID') !== null && msps.length > 0) {
            return await db.collection("users").doc(auth.currentUser?.uid).get().then(async (user) => {
              if (user.exists) {
                let roles = await user.data()?.roles;
                let organisations = await user.data()?.organisations;
                let fetchURL = (window.location.hostname.includes('localhost') || window.location.hostname.includes("127.0.0.1")) ? window.apiURL : import.meta.env.VITE_cloudFunctionURL;

                if (!fetchURL.includes('deiterateInternalAPI')) { fetchURL = fetchURL.replace(/\/+$/, '') + '/deiterateInternalAPI'; }

                onAuthReady(async () => {
                  for (const msp of msps) {
                    return await getValidToken(auth).then(async (idToken) => {
                      return await fetch(`${fetchURL}/assurance/getAssignee`, {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          "Authorization": `Bearer ${idToken}`,
                          "Company-ID": window.companyID,
                        },
                        // mode: 'no-cors',
                        body: JSON.stringify({
                          customerID: window.companyID,
                          mspID: msp,
                          msp: roles?.msp !== undefined && organisations[0] == msp ? true : false
                        })
                      }).then((res) => res.json()).then((res) => {
                        console.log(res)
                        if (!Array.isArray(window.assignees)) {
                          window.assignees = [];
                        }
                        if (res.assignees && Array.isArray(res.assignees)) {
                          window.assignees = window.assignees.concat(res.assignees);
                        }
  
                        if (Array.isArray(window.assignees)) {
                          window.assignees = window.assignees.filter((item, index, self) =>
                            item && (item.userID
                              ? index === self.findIndex((obj) =>
                                  obj && item &&
                                  (obj.userID !== undefined && item.userID !== undefined
                                    ? obj.userID === item.userID
                                    : obj.mspID === item.mspID)
                                )
                              : true)
                          );
                        }
  
                        console.log(window.assignees)
                        return window.assignees;
                      })
                    })
                  }
                })
              }
            })
          } else {
            return await db.collection("users").doc(auth.currentUser?.uid).get().then(async (user) => {
              if (user.exists) {
                let roles = user.data()?.roles;
                let fetchURL = (window.location.hostname.includes('localhost') || window.location.hostname.includes("127.0.0.1"))
                  ? window.apiURL
                  : import.meta.env.VITE_cloudFunctionURL;

                if (!fetchURL.includes('deiterateInternalAPI')) { fetchURL = fetchURL.replace(/\/+$/, '') + '/deiterateInternalAPI'; }

                onAuthReady(async () => {
                  return await getValidToken(auth).then(async (idToken) => {
                    // Enhanced API request with MSP context
                    return await fetch(`${fetchURL}/assurance/getAssignee`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${idToken}`,
                        "Company-ID": window.companyID,
                      },
                      // mode: 'no-cors',
                      body: JSON.stringify({
                        customerID: window.companyID,
                        mspID: sessionStorage.getItem('web-mspID'),
                        msp: roles?.msp !== undefined ? true : false,
                        isMSPContext: !!sessionStorage.getItem('web-mspID')
                      })
                    }).then((res) => res.json()).then((res) => {
                      console.log('Assignee response:', res);
                      if (!Array.isArray(window.assignees)) {
                        window.assignees = [];
                      }
  
                      // Handle MSP owner assignee from response
                      if (res.mspOwner) {
                        window.assignees.push(res.mspOwner);
                      }
                      if (res.assignees && Array.isArray(res.assignees)) {
                        window.assignees = window.assignees.concat(res.assignees);
                      }
  
                      // Deduplicate assignees giving priority to MSP entries
                      if (Array.isArray(window.assignees)) {
                        window.assignees = window.assignees.filter((item, index, self) =>
                          item && (item.userID
                            ? index === self.findIndex((obj) =>
                                obj && item &&
                                (obj.userID !== undefined && item.userID !== undefined
                                  ? obj.userID === item.userID
                                  : obj.mspID === item.mspID))
                            : true)
                        );
                      }
  
                      return window.assignees;
                    })
                  })
                })
              }
            })
          }
        });
      }

    });
}
